import { GridColDef, GridColumnGroupingModel } from "@mui/x-data-grid";
import ActionsCell from "../components/dashboard/actionButton";
import { GridRenderCellParams } from "@mui/x-data-grid";
import React from "react";
import { decodedJWT, formatNumberToIndianNotation, getOwnerType, getUserRole } from "../utils/commonUtils";
import RoleManagement from "../security/roleManagement";
import FocusedCaseIcon from '@mui/icons-material/Star';
import NormalCaseIcon from '@mui/icons-material/StarBorder';

const token = decodedJWT();

export const caseColumnGroup: GridColumnGroupingModel = [
    { groupId: 'Case Data', children: [
        { field: 'client_reference_id' },
        { field: 'focused' },
        { field: 'customer_id'},
        { field: 'pool_month' },
        { field: 'case_id' },
        { field: 'client_name' },
        { field: 'agency_name' },
        { field: 'client_manager_username' },
        { field: 'loan_type' },
        { field: 'dpd_bucket' },
        { field: 'customer_name' },
        { field: 'customer_phone_number' },
        { field: 'assigned_agents' },
        { field: 'total_due_amount' },
        { field: 'principal_outstanding_amount' },
        { field: 'collected_amount' },
        { field: 'min_due_amount' },
        { field: 'eligible_settlement_amount' },
        { field: 'status' },
    ] },
    { groupId: 'Latest Interaction', children: [
        { field: 'latest_interaction' },
        { field: 'latest_sub_interaction' },
        { field: 'latest_rest_interaction' },
        { field: 'latest_ptp_date' },
        { field: 'latest_followup_date' },
        { field: 'latest_comment' },
        { field: 'latest_interaction_date' },
        { field: 'latest_interaction_mode' },
        { field: 'latest_interaction_type' },
    ] },
    { groupId: 'Best Interaction', children: [
        { field: 'best_interaction' },
        { field: 'best_sub_interaction' },
        { field: 'best_rest_interaction' },
        { field: 'best_ptp_date' },
        { field: 'best_followup_date' },
        { field: 'best_comment' },
        { field: 'best_interaction_date' },
        { field: 'best_interaction_mode' },
        { field: 'best_interaction_type' },
    ] },
    { groupId: 'Latest Call Interaction', children: [
        { field: 'latest_call_interaction' },
        { field: 'latest_call_sub_interaction' },
        { field: 'latest_call_rest_interaction' },
        { field: 'latest_call_ptp_date' },
        { field: 'latest_call_followup_date' },
        { field: 'latest_call_comment' },
        { field: 'latest_call_interaction_date' },
        { field: 'latest_call_interaction_mode' },
        { field: 'latest_call_interaction_type' },
    ] },
    { groupId: 'Best Call Interaction', children: [
        { field: 'best_call_interaction' },
        { field: 'best_call_sub_interaction' },
        { field: 'best_call_rest_interaction' },
        { field: 'best_call_ptp_date' },
        { field: 'best_call_followup_date' },
        { field: 'best_call_comment' },
        { field: 'best_call_interaction_date' },
        { field: 'best_call_interaction_mode' },
        { field: 'best_call_interaction_type' },
    ] },
    { groupId: 'Latest Visit Interaction', children: [
        { field: 'latest_visit_interaction' },
        { field: 'latest_visit_sub_interaction' },
        { field: 'latest_visit_rest_interaction' },
        { field: 'latest_visit_ptp_date' },
        { field: 'latest_visit_followup_date' },
        { field: 'latest_visit_comment' },
        { field: 'latest_visit_interaction_date' },
        { field: 'latest_visit_interaction_mode' },
        { field: 'latest_visit_interaction_type' },
    ] },
    { groupId: 'Best Visit Interaction', children: [
        { field: 'best_visit_interaction' },
        { field: 'best_visit_sub_interaction' },
        { field: 'best_visit_rest_interaction' },
        { field: 'best_visit_ptp_date' },
        { field: 'best_visit_followup_date' },
        { field: 'best_visit_comment' },
        { field: 'best_visit_interaction_date' },
        { field: 'best_visit_interaction_mode' },
        { field: 'best_visit_interaction_type' },
    ] },
    { groupId: 'Pincode Data', children: [
        { field: 'pin_code' },
        { field: 'area' },
        { field: 'state' },
        { field: 'district' },
    ] },
    { groupId: 'Timestamps', children: [
        { field: 'created_date' },
        { field: 'updated_date' },
        { field: 'updated_by' }
    ] }
];


export const caseColumnDef: GridColDef[] = [
    {
        field: 'focused',
        headerName: 'Focused Case',
        width: 50,
        filterable: false,
        sortable: false,
        hideable: false,
        renderCell: (params: GridRenderCellParams<any, any, any>) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                }}
            >
                {params.value ? (
                    <FocusedCaseIcon sx={{ color: 'orange', fontSize: 20 }} />
                ) : (
                    <NormalCaseIcon sx={{ fontSize: 20, opacity: 0.7 }} />
                )}
            </div>
        ),
    },
    {
        field: 'client_reference_id',
        headerName: 'Client Reference ID',
        renderCell: (params: GridRenderCellParams<any, any, any>) => <ActionsCell currentCaseRow={params.row} />,
        width: 300,
        filterable: true,
        sortable: true,
        hideable: false,
    },
    { field: 'pool_month', headerName: 'Pool Month', width: 150, filterable: false, sortable: false, hideable: false },
    { field: 'case_id', headerName: 'ID', width: 90, filterable: false, sortable: false, hideable: false },
    { field: 'customer_id', headerName: 'Customer Id', width: 90, filterable: false, sortable: false, hideable: false },
    { field: 'client_name', headerName: 'Client Name', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'agency_name', headerName: 'Agency Name', width: 150, filterable: true, sortable: true, hideable: false },
    ...(token && RoleManagement.isClient(getOwnerType(token)) ?
        [{ field: 'client_manager_username', headerName: 'Client Manager Name', width: 150, filterable: true, sortable: true, hideable: false }]
        : []),
    { field: 'loan_type', headerName: 'Loan Type', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'dpd_bucket', headerName: 'DPD Bucket', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'customer_name', headerName: 'Customer Name', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'customer_phone_number', headerName: 'Customer Contact', width: 150, filterable: true, sortable: true, hideable: false },
    ...(token && RoleManagement.isAgency(getOwnerType(token)) && !RoleManagement.isAgent(getUserRole(token)) ?
        [{ field: 'assigned_agents', headerName: 'Assigned To', width: 150, filterable: true, sortable: true, hideable: false }]
        : []),
    { field: 'total_due_amount', headerName: 'Total Overdue Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'principal_outstanding_amount', headerName: 'Principal Outstanding Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'collected_amount', headerName: 'Collected Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'min_due_amount', headerName: 'Minimum Due Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'eligible_settlement_amount', headerName: 'Eligible Settlement Amount', width: 150, filterable: true, sortable: true, hideable: false, valueFormatter: formatNumberToIndianNotation, align: 'right' },
    { field: 'status', headerName: 'Status', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'latest_interaction', headerName: 'Latest L0 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_sub_interaction', headerName: 'Latest L1 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_rest_interaction', headerName: 'Latest Sub Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_ptp_date', headerName: 'Latest PTP Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_followup_date', headerName: 'Latest Follow up Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_comment', headerName: 'Latest Comment', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_interaction_date', headerName: 'Latest Interaction Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_interaction_mode', headerName: 'Latest Interaction Mode', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_interaction_type', headerName: 'Latest Interaction Type', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_interaction', headerName: 'Best L0 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_sub_interaction', headerName: 'Best L1 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_rest_interaction', headerName: 'Best Sub Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_ptp_date', headerName: 'Best PTP Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_followup_date', headerName: 'Best Follow up Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_comment', headerName: 'Best Comment', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_interaction_date', headerName: 'Best Interaction Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_interaction_mode', headerName: 'Best Interaction Mode', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_interaction_type', headerName: 'Best Interaction Type', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_interaction', headerName: 'Latest Call L0 Interaction', width: 250, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_sub_interaction', headerName: 'Latest Call L1 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_rest_interaction', headerName: 'Latest Call Sub Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_ptp_date', headerName: 'Latest Call PTP Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_followup_date', headerName: 'Latest Call Follow up Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_comment', headerName: 'Latest Call Comment', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_interaction_date', headerName: 'Latest Call Interaction Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_call_interaction_type', headerName: 'Latest Call Interaction Type', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_interaction', headerName: 'Best Call L0 Interaction', width: 250, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_sub_interaction', headerName: 'Best Call L1 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_rest_interaction', headerName: 'Best Call Sub Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_ptp_date', headerName: 'Best Call PTP Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_followup_date', headerName: 'Best Call Follow up Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_comment', headerName: 'Best Call Comment', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_interaction_date', headerName: 'Best Call Interaction Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_call_interaction_type', headerName: 'Best Call Interaction Type', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_interaction', headerName: 'Latest Visit L0 Interaction', width: 250, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_sub_interaction', headerName: 'Latest Visit L1 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_rest_interaction', headerName: 'Latest Visit Sub Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_ptp_date', headerName: 'Latest Visit PTP Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_followup_date', headerName: 'Latest Visit Follow up Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_comment', headerName: 'Latest Visit Comment', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_interaction_date', headerName: 'Latest Visit Interaction Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'latest_visit_interaction_type', headerName: 'Latest Visit Type', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_interaction', headerName: 'Best Visit L0 Interaction', width: 250, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_sub_interaction', headerName: 'Best Visit L1 Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_rest_interaction', headerName: 'Best Visit Sub Interaction', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_ptp_date', headerName: 'Best Visit PTP Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_followup_date', headerName: 'Best Visit Follow up Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_comment', headerName: 'Best Visit Comment', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_interaction_date', headerName: 'Best Visit Interaction Date', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'best_visit_interaction_type', headerName: 'Best Visit Interaction Type', width: 225, filterable: true, sortable: true, hideable: true },
    { field: 'pin_code', headerName: 'Pin Code', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'area', headerName: 'Area', width: 150, filterable: false, sortable: false, hideable: false },
    { field: 'state', headerName: 'State', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'district', headerName: 'District', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'created_date', headerName: 'Created Date', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'updated_date', headerName: 'Last Update Date', width: 150, filterable: true, sortable: true, hideable: false },
    { field: 'updated_by', headerName: 'Last Update By', width: 150, filterable: true, sortable: true, hideable: false },
];
